import React from "react";
import { Switch } from "@/components/ui/switch";
import { Skeleton } from "@/components/ui/skeleton";
import { RecurringEmailSubscription } from "@/api/fetchRecurringEmailSubscriptions/types";

interface RecurringEmailSubscriptionsProps {
  subscriptions: RecurringEmailSubscription[];
  loading: boolean;
  updatingRecurringEmail: string | null;
  onToggle: (recurringEmail: string, isSubscribed: boolean) => void;
}

const RecurringEmailSubscriptions: React.FC<
  RecurringEmailSubscriptionsProps
> = ({ subscriptions, loading, updatingRecurringEmail, onToggle }) => {
  if (loading) {
    return <Skeleton className="h-10 w-full" />;
  }

  return (
    <div className="divide-y divide-gray-200 dark:divide-slate-700">
      {subscriptions.map((subscription) => (
        <div
          className="flex items-center justify-between py-3 first:pt-0 last:pb-0"
          key={subscription.recurringEmail}
        >
          <span className="text-sm font-normal text-gray-900 dark:text-white">
            {subscription.label}
          </span>
          <Switch
            checked={subscription.isSubscribed}
            disabled={updatingRecurringEmail !== null}
            onCheckedChange={(checked) =>
              onToggle(subscription.recurringEmail, checked)
            }
          />
        </div>
      ))}
    </div>
  );
};

export default RecurringEmailSubscriptions;
